import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=3423ba52&scoped=true&"
import script from "./LoadingButton.vue?vue&type=script&lang=js&"
export * from "./LoadingButton.vue?vue&type=script&lang=js&"
import style0 from "./LoadingButton.vue?vue&type=style&index=0&id=3423ba52&prod&lang=scss&scoped=true&"
import style1 from "./LoadingButton.vue?vue&type=style&index=1&id=3423ba52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423ba52",
  null
  
)

export default component.exports